<div class="p2">
  <div class="flex">
    @if (authors$ | async; as authors) {
      <div class="dca-width">
        <div cdkDropList (cdkDropListDropped)="drop($event)">
          @if (authors.length === 0) {
            <div class="m1">
              There are currently no authors in this document. To add one, click
              <mat-icon>playlist_add</mat-icon> above.
            </div>
          }
          @for (author of authors; track author.authorId) {
            <div cdkDrag>
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              <sf-user-card
                [user]="author"
                [class]="((selectedAuthorId$ | async) == author.authorId) ? 'selected' : ''"
                class="mb1 card-interactive"
                (click)="selectAuthor(author.authorId)"
              ></sf-user-card>
              <div class="drag-placeholder" *cdkDragPlaceholder></div>
            </div>
          }
        </div>
      </div>
    }
    @if (selectedAuthorId$ | async; as authorId) {
      <sf-author-edit
        [authorId]="authorId"
        [isAuthor]="true"
        (closed)="onClosedEdit()"
        (createNew)="onClosedEdit()"
        (update)="onChange($event)"
      ></sf-author-edit>
    }
  </div>
</div>
